import { round } from 'lodash';
import { NOT_DIGIT_OR_DOT_REGEX } from '@/utils/regex.util';

const DECIMAL_PLACES = 2;

// Keep only digits and a single decimal separator; a comma is treated as a dot
export const sanitizeDecimalInput = (rawValue: string): string => {
  const normalizedValue = rawValue.replace(',', '.').replace(NOT_DIGIT_OR_DOT_REGEX, '');
  const [integerPart, ...fractionParts] = normalizedValue.split('.');

  return fractionParts.length ? `${integerPart}.${fractionParts.join('')}` : integerPart;
};

export const roundDecimalValue = (
  value: number | string | null,
  decimalPlaces: number = DECIMAL_PLACES,
): number | null => {
  if (value === null || value === '' || Number.isNaN(Number(value))) {
    return null;
  }

  return round(Number(value), decimalPlaces);
};
